import React, { useEffect, useState } from 'react';
import { pb } from '../config/pocketbase';

/**
 * Componente di Diagnostica Connessione Database
 * Verifica lo stato di salute di PocketBase self-hosted su aaPanel (pb.wawave.org).
 * In caso di connessione attiva (normale operatività), ritorna null e non mostra alcun popup.
 */
const ConnectionDebug = () => {
  const [status, setStatus] = useState('checking');
  const [details, setDetails] = useState('');

  useEffect(() => {
    checkConnection();
  }, []);

  const checkConnection = async () => {
    try {
      // 1. Health check o query rapida su PocketBase (100% Free self-hosted)
      const res = await pb.collection('menu_tap2order').getList(1, 1, {
        requestKey: null
      });

      if (res) {
        setStatus('success');
        setDetails('Connessione PocketBase attiva e funzionante!');
      }
    } catch (err) {
      // Prova fallback health check
      try {
        const health = await pb.health.check();
        if (health?.code === 200) {
          setStatus('success');
          return;
        }
      } catch (healthErr) {
        console.warn('[ConnectionDebug] PocketBase non raggiungibile:', err?.message || healthErr?.message);
        setStatus('error');
        setDetails(err?.message || 'Impossibile contattare il server PocketBase.');
      }
    }
  };

  // Se tutto funziona regolarmente, non mostrare nulla a schermo
  if (status === 'success') return null;

  // Durante il check iniziale non mostrare alert invasivi
  if (status === 'checking') return null;

  return (
    <div className="fixed bottom-4 right-4 max-w-md bg-white border-l-4 border-amber-500 shadow-xl rounded-lg p-4 z-[9999]">
      <div className="flex items-center justify-between">
        <h3 className="font-bold text-amber-700 flex items-center gap-2">
          <span>⚡</span> Diagnostica Database Tap2Order
        </h3>
        <button
          onClick={() => setStatus('success')}
          className="text-gray-400 hover:text-gray-600 text-sm font-bold ml-2"
        >
          ✕
        </button>
      </div>
      <div className="mt-2 text-sm text-gray-600">
        <p className="font-semibold text-xs">Stato: <span className="text-amber-600 uppercase">{status}</span></p>
        <p className="mt-1 font-mono bg-gray-50 p-2 rounded text-xs break-all border border-gray-200">
          {details}
        </p>
        <div className="mt-2 text-xs text-gray-500">
          <p>Backend: <code>https://pb.wawave.org</code></p>
        </div>
      </div>
    </div>
  );
};

export default ConnectionDebug;